import {CSSProperties} from 'react';
import {cn} from '@/lib/utils';
import {Icon} from '../../../app/components/Icon';
import styles from './CategoryArrow.module.css';
export interface CategoryArrowProps {
  className?: string;
  style?: CSSProperties;
}
export const CategoryArrow = ({className, style}: CategoryArrowProps) => {
  return (
    <div className={cn(styles.categoryArrow, className)} style={style}>
      <div className={styles.tail} />
      <Icon className={styles.arrow} icon="angle-right" />
    </div>
  );
};
